import { NextPage } from "next";
import NotFoundPage from "pages/404";

import { deserializeProps } from "src/utilities/ssr/superjson";

export function withPropsDeserialization(
  PageComponent: NextPage<any>
): NextPage<any> {
  const Wrapped: NextPage<any> = (props) => {
    const deserializedProps =
      props?.json && props?.meta ? deserializeProps(props) : props;

    if (deserializedProps?.notFound) {
      return <NotFoundPage />;
    }

    return <PageComponent {...deserializedProps} />;
  };

  return Wrapped;
}
